import {
  CLEANLINESS_BAND_LABELS,
  getCleanlinessBand,
} from '../../../utils/cleanliness-score-band'
import styles from './styles.module.css'

interface ICleanlinessScoreChipProps {
  score: number | null
  label?: string // overrides the number, e.g. a legend range
  size?: 'small' | 'large'
}

function formatScore(score: number | null): string {
  return score === null ? '—' : Math.round(score).toString()
}

/** A 0-100 cleanliness score colored by its band; a dash when unscored. */
function CleanlinessScoreChip({
  score,
  label,
  size = 'small',
}: ICleanlinessScoreChipProps) {
  const band = getCleanlinessBand(score)
  return (
    <span
      className={`${styles.chip} ${styles[band]} ${
        size === 'large' ? styles.large : ''
      }`}
      title={CLEANLINESS_BAND_LABELS[band]}
    >
      {label ?? formatScore(score)}
    </span>
  )
}

export default CleanlinessScoreChip
